import * as React from "react";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
const PhoneNumber = ({ label, errorMessage, ...rest }) => /* @__PURE__ */ React.createElement(
  ConnectedFormControl,
  {
    ...ConnectedFormControl.defaultProps,
    id: "phone",
    "data-t": "phone-number",
    type: "tel",
    label,
    errorMessage,
    ...rest
  }
);
export {
  PhoneNumber as default
};
//# sourceMappingURL=PhoneNumber.js.map
